'use client'

import { useCookiesContext } from 'cookies/hooks/useCookiesContext/useCookiesContext'
import Script from 'next/script'
import { isBot } from 'utils/isBot/IsBot'
import { URL } from '../../constants/CIAM'
import { useCIAM } from '../../hooks/CIAM/useCIAM/useCIAM'

export function CustomerIdentityAccessManagement() {
	const { enabled, initialize } = useCIAM()
	const { cookiesConsent } = useCookiesContext()

	const init = () => {
		initialize()
	}

	if (!enabled || isBot() || typeof cookiesConsent !== 'boolean') {
		return null
	}

	return <Script src={URL} strategy='afterInteractive' onLoad={init} />
}
